import Vue from 'vue';
import VueMeta from 'vue-meta'
import { InertiaApp } from '@inertiajs/inertia-vue';

Vue.use(VueMeta);
Vue.use(InertiaApp);

// Vuex Store
import vuexStore from './store';

// Vee validate
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { regex, required, email } from 'vee-validate/dist/rules';

extend('regex', {
    ...regex,
    message: 'Vul een geldige waarde in'
});

extend('required', {
    ...required,
    message: 'Dit veld mag niet leeg zijn'
});

extend('email', {
    ...email,
    message: 'Vul een geldig e-mailadres in'
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

const app = document.getElementById('app');

new Vue({
	metaInfo: {
		titleTemplate: (title) => title ? `${title} - Bereikbaar` : 'Bereikbaar'
	},

    render: h => h(InertiaApp, {
        props: {
            initialPage: JSON.parse(app.dataset.page),
            resolveComponent: name => require(`@/pages/${name}`).default,
        }
    }),

    store: vuexStore
}).$mount(app);
